import axiosInstance from '@/app/api/axiosInstance';
import { QuotationCreate, QuotationUpdate, QuotationResponse, DocumentStatusEnum } from '@/app/types/quotation';
import { PaginatedResponse } from '@/app/types/api';
import { SalesOrder } from '@/app/types/salesOrder';

export interface QuotationParams {
  skip?: number;
  limit?: number;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
  search_query?: string;
  status?: DocumentStatusEnum;
  start_date?: string;
  end_date?: string;
  filters?: string;
}

/**
 * Get a paginated list of quotations
 */
export const listQuotations = async (params: QuotationParams): Promise<PaginatedResponse<QuotationResponse>> => {
  const response = await axiosInstance.get('/quotations/', { params });
  return response.data;
};

/**
 * Get a specific quotation by ID
 */
export const getQuotation = async (id: number): Promise<QuotationResponse> => {
  const response = await axiosInstance.get(`/quotations/${id}`);
  return response.data;
};

/**
 * Create a new quotation
 */
export const createQuotation = async (data: QuotationCreate): Promise<QuotationResponse> => {
  const response = await axiosInstance.post('/quotations/', data);
  return response.data;
};

/**
 * Update an existing quotation
 */
export const updateQuotation = async (id: number, data: QuotationUpdate): Promise<QuotationResponse> => {
  const response = await axiosInstance.patch(`/quotations/${id}`, data);
  return response.data;
};

/**
 * Update the status of a quotation
 */
export const updateQuotationStatus = async (
  id: number, 
  status: DocumentStatusEnum, 
  notes?: string
): Promise<QuotationResponse> => {
  const response = await axiosInstance.patch(`/quotations/${id}/status`, { status, notes });
  return response.data;
};

/**
 * Convert a quotation to a sales order
 */
export const convertQuotationToSalesOrder = async (id: number): Promise<SalesOrder> => {
  const response = await axiosInstance.post(`/quotations/${id}/convert-to-sales-order`);
  return response.data;
};

/**
 * Delete a quotation (if implemented in the backend)
 */
export const deleteQuotation = async (id: number): Promise<void> => {
  await axiosInstance.delete(`/quotations/${id}`);
}; 